import styled from '@emotion/styled';
import { createElement, FC, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import { useGetInsightCategories } from '../../hooks/useGetInsightCategories';
import { useGetOrganizationId } from '../../hooks/useGetOrganizationId';
import { useNeedSignedIn } from '../../hooks/useNeedSignedIn';
import LatestInsightsList from '../component/compound/LatestInsightsList';
import { SCREEN_LARGE } from '../constant/pageWidth';
import { SPACING_HUGE, SPACING_REGULAR, SPACING_UNIT } from '../constant/spacing';
import { context as stateContext } from '../context/state';
import mq from '../styleUtility/mediaquery';

type Props = RouteComponentProps<{
  categoryId: string;
}>;

const InsightCategoryPage: FC<Props> = ({ match }) => {
  const { language } = useContext(stateContext);
  const { organizationId } = useGetOrganizationId();

  useNeedSignedIn();
  const { insightCategories, loading: insightCategoriesLoading } = useGetInsightCategories({
    language,
    organizationId,
  });

  const category = insightCategories?.find((category) => category.id === match.params.categoryId);

  return (
    <Root>
      <LatestInsightsList
        loading={insightCategoriesLoading}
        showEmptyState={category === null}
        insightCategories={category != null ? [category] : []}
        isSingleCategoryPage
      />
    </Root>
  );
};

const Root = styled('div')`
  width: auto;
  max-width: ${SCREEN_LARGE}px;
  margin-top: ${SPACING_HUGE}px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: ${SPACING_UNIT * 12}px;

  ${mq('sp')} {
    padding-left: ${SPACING_REGULAR}px;
    padding-right: ${SPACING_REGULAR}px;
  }
`;

export default InsightCategoryPage;
